import { Button, Col, PageHeader, Row, Select, Space } from "antd";
import tabsConfig from "config/tabsConfig";
import LayoutCss from "layout/layout.module.scss";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LookupTable from "redux/models/lookupTable";
import { selectConfigration } from "redux/slices/configrationSlice";
import { selectUser, selectUserId } from "redux/slices/userSlice";
import K from "utilities/constants";
import LookupTableModal from "./lookupTableModal";
import { DataTableLayout } from "../../../common/components/dataTableLayout/dataTableLayout";
import { ClientSideDataGrid } from "../../../common/components/clientSideDataGrid/clientSideDataGrid";
import { usePageFilter } from "../../../hooks/usePageFilters";
import AgGridUtility from "../../../utilities/agGridUtility";
import { getColumns } from "./columns";
import { ParseString, useQueryState } from "../../../hooks/useQueryState";

export const LookupTables = () => {
  const dispatch = useDispatch();

  const userId = useSelector(selectUserId);
  const userSlice = useSelector(selectUser);
  const lookData = useSelector(selectConfigration).lookup;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editData, setEditData] = useState({});

  const [search, setSearch] = usePageFilter("lookups_search");

  const [tableParam, setTableParam] = useQueryState("table", "source");

  const getLookupData = async (tab) => {
    try {
      await dispatch(LookupTable.getData(tab.reduxKey, tab.apiEndPoint));
    } catch (error) {
      console.error(error);
    }
  };

  const addNewRecord = () => {
    setEditData({});
    setIsModalVisible(true);
  };

  const editRecord = (params) => {
    setEditData(params.data);
    setIsModalVisible(true);
  };

  const columns = useMemo(
    () => getColumns(userSlice.roles, editRecord),
    [userSlice.roles],
  );

  useEffect(() => {
    getLookupData(tabsConfig[tableParam]);
  }, [tableParam]);

  return (
    <>
      <PageHeader
        ghost={false}
        className={`LookupTablePageHeader ${LayoutCss.appPageHeader}`}
        title="Lookup Table"
      />

      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <Row justify="end">
          <Col style={{ width: 200 }}>
            <Select
              style={{ width: "100%" }}
              showSearch
              optionFilterProp="label"
              onChange={setTableParam}
              value={tableParam}
              options={Object.keys(tabsConfig).map((key) => ({
                value: key,
                label: tabsConfig[key].name,
              }))}
            />
          </Col>
        </Row>
        <DataTableLayout
          searchDefaultValue={search}
          onSearchChange={setSearch}
          actions={[
            {
              permissions: [K.Permissions.CreateLookup],
              renderer: () => (
                <Col>
                  <Button type="primary" onClick={addNewRecord}>
                    Add New
                  </Button>
                </Col>
              ),
            },
          ]}
        >
          <ClientSideDataGrid
            userId={userId}
            configKey={K.AgGridTable.Keys.LookupVisibleColumn}
            defaultColumnConfig={columns}
            rowData={lookData[tabsConfig[tableParam]?.reduxKey]}
            quickFilterText={search}
            getContextMenuItems={() => AgGridUtility.menuItemsWithExport}
          />
        </DataTableLayout>

        <LookupTableModal
          isVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
          editData={editData}
          setEditData={setEditData}
          table={tableParam}
        />
      </Space>
    </>
  );
};
